export enum ProcedureType {
  ACTION = 'action',
  INCIDENT = 'incident',
}
